// @vendors
import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

// @components
import WizardError from 'components/commons/wizardError/wizardError';

// @utilities
import { recordLink, PROC_ADD_ENTITY, PROC_START, EVENT_ADD_MORE_ENTITY } from 'utilities/tagging';
const { formatText } = require('core/i18n').i18n;

function InsertEntityCredentialsErrorView({ history }) {

    const handleOnClickButton = () => {
        recordLink(PROC_ADD_ENTITY, PROC_START, EVENT_ADD_MORE_ENTITY)
        history.push('/myprofile/global')
    }

    return (
        <WizardError
            errorMessage={formatText('aggregatorAddEntity-errorTitle')}
            customClassName="aggregator-add-entity__wizard__wizard-step-login__form__form__wizard-error"
            mainButton={{
                label: formatText("aggregatorAddEntity-backToGlobalPosition")
            }}
            onMainButtonClick={handleOnClickButton}
            processType={PROC_ADD_ENTITY}
        >
            <p>{formatText('aggregatorAddEntity-errorMessage')}</p>
        </WizardError>
    );
}

InsertEntityCredentialsErrorView.propTypes = {
    history: PropTypes.object.isRequired,
}

export default withRouter(InsertEntityCredentialsErrorView);
